import { template as template_635df0c1faa144faa1467d579e7d5244 } from "@ember/template-compiler";
import { isTesting as isTestingMacro, macroCondition } from '@embroider/macros';
// eslint-disable-next-line no-unneeded-ternary
const isTesting = macroCondition(isTestingMacro()) ? true : false;
export default template_635df0c1faa144faa1467d579e7d5244(`
{{#unless isTesting}}
  <div
    class="component-spinner spinner text-primary {{if @belowSidePanel 'spinner-below-side-panel'}}"
    ...attributes
  >
    <div class="spinner-border" role="status"></div>
  </div>
{{/unless}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
